/**
 * De stijlen die meer dan één stap van het leerlingscherm gebruikt.
 *
 * Een stap spreidt dit uit in zijn eigen `styles` en zet daar achter wat
 * alleen die stap nodig heeft: `const styles = { ...basis, ...eigen }`.
 * Wat hier staat is wat in twee of meer stappen letterlijk gelijk was.
 */
import { kleur } from '../../theme/tokens';
import { gedeeld } from '../../theme/stijlen';

export const basis = {
  ...gedeeld,
  card: { background: 'white', padding: '32px' },
  // de kop van een stap: het nummer in een rondje, titel, ondertitel
  stepHeader: { display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px' },
  stepNumber: { width: '40px', height: '40px', background: kleur.accent, color: 'white', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', fontWeight: 'bold' },
  stepTitle: { margin: 0, fontSize: '20px' },
  stepSubtitle: { margin: 0, color: kleur.stil, fontSize: '14px' },
  // knoppen
  btn: { padding: '12px 24px', background: kleur.accent, color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '16px' },
  btnSecondary: { padding: '12px 24px', background: kleur.lijn, color: kleur.tekst, border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '16px' },
  btnDisabled: { padding: '12px 24px', background: kleur.lijnUit, color: kleur.grijs, border: 'none', borderRadius: '8px', cursor: 'not-allowed', fontSize: '16px' },
  buttonRow: { display: 'flex', justifyContent: 'space-between', gap: '12px' },
  // de stelling in een kader
  stellingCard: { background: kleur.vlak, borderRadius: '12px', padding: '20px', marginBottom: '24px', borderLeft: `4px solid ${kleur.accent}` },
  stellingLabel: { fontSize: '14px', color: kleur.stil, marginBottom: '8px' },
  stellingTekst: { fontSize: '20px', fontWeight: 'bold', color: kleur.inkt, margin: 0 },
  // het groepje en de tijdklok in de kop van chat en argumenten
  groupBadge: { display: 'inline-flex', flexDirection: 'column', gap: '2px', padding: '8px 16px', background: kleur.accentLicht, borderRadius: '20px', fontSize: '14px' },
  groupLeden: { fontSize: '13px', opacity: 0.8 },
  timer: { background: kleur.accent, color: 'white', padding: '8px 16px', borderRadius: '20px', fontSize: '16px', fontWeight: 'bold' },
  timerWarning: { background: kleur.rood, color: 'white', padding: '8px 16px', borderRadius: '20px', fontSize: '16px', fontWeight: 'bold', animation: 'pulse 1s infinite' },
  // tekst
  uitleg: { fontSize: '14px', color: kleur.tekstGrijs, lineHeight: 1.5, margin: '0 0 12px' },
  emptyState: { textAlign: 'center', padding: '20px' },
  emptyIcon: { fontSize: '64px', display: 'block', marginBottom: '16px' },
};
